import * as activationStatusTypes from '../../consts/uam/activationStatusTypes';

export const uamAssetsMapping = (data, isHolder) => ({
    serialNumber: data?.device?.serialNumber,
    yapActivated: data?.device?.yapActivationStatus?.toLowerCase() === activationStatusTypes.UAM_ACTIVATED,
    material: data?.material,
    isHolder: !!isHolder,
    configurationCode: data?.device?.configurationCode,
    sblMajorVersion: data.device?.sblMajorVersion,
    associatedDevices: data.device?.associatedDevices,
});

export const uamActivationStatusMapping = (data) => ({
    isActivated: data?.activationStatus?.toLowerCase() === activationStatusTypes.UAM_ACTIVATED,
});
